<template>
    <div :class="`DshCheckbox ycFormItem control-${mode}`">
        <!-- <template
            v-if="canEdit"> -->
        <!-- 平铺 -->
        <CheckboxGroup
            v-if="propsObj._optionKind === 'flat'"
            :class="[
                    'DshCheckbox-checkboxGroup',
                    { 'DshCheckbox-checkboxGroup-useColor' : propsObj._useColor },
                    { 'readonlyCheckbox' : !propsObj._useColor && !canEdit },
                    { 'readonlyColorCheckbox': propsObj._useColor && !canEdit}
                ]"
            v-model="value[propsObj._key]"
            @on-change="change"
        >
            <template v-if="listData.length">
                <Checkbox
                    v-for="(item, index) in listData"
                    :key="index"
                    :class="['myChecked ', 'type-item-' + (colorArr.indexOf(item.color) + 1), propsObj.class]"
                    :label="item._key"
                    :style="{
                            backgroundColor: propsObj._useColor ? item.color : ''
                        }"
                    :border="propsObj._useColor"
                    :disabled="isDisabled(item)"
                    @click.native="clickOpenTip(item)"
                >
                    <slot :item="item"></slot>
                    <span>{{ item.name || item._name }}</span>
                </Checkbox>
            </template>

            <div
                v-else
                class="dsh-subtip"
                style="backgroundColor: #f3f3f3;"
            >-- 无选择项 --</div>
        </CheckboxGroup>

        <!-- 下拉 属性clearable只有单选有效 -->
        <Select
            v-else
            v-model="value[propsObj._key]"
            :class="{
                    'DshCheckbox-select-readonly': $isReadonly(canEdit, propsObj),
                    'DshCheckbox-select-disabled': $isDisabled(canEdit, propsObj)
                }"
            :placeholder="$showPlaceholder(canEdit, propsObj) ? `请选择${propsObj._name}` : ''"
            :multiple="true"
            :disabled="!finalCanEdit"
            :filterable="false"
            :transfer="true"
            @on-select="select"
        >
            <Option
                v-for="(item, index) in listData"
                :key="index"
                :value="item._key"
                :label="item.name || item._name"
                :disabled="isDisabled(item)"
            >
                <slot :item="item"></slot>
                <span>{{ item.name || item._name }}</span>
                <span style="float:right;paddingRight:20px">{{ item.rightName }}</span>
            </Option>
        </Select>
        <!-- </template>

         <div v-else style="display:flex;overflow:hidden;">
             <template v-if="colData&&colData.length">
                 <Ctooltip
                    v-for="data in colData"
                    placement="top"
                    :transfer="true"
                    :content="data.name"
                    :key="data.id"
                    style="min-width:35px;margin-left:3px;"
                >
                    <div class="dsh-ellipsis DshCheckbox-content"
                        :style='{
                            background: propsObj._useColor ? data.color : "",
                            color: propsObj._useColor ? "#fff" : ""
                        }'>
                        {{  data.name }}
                    </div>
                </Ctooltip>
             </template>
             <template v-else>
                 <span>{{ value[propsObj._key]}}</span>
             </template>
         </div> -->

        <!-- tip项弹框提示 -->
        <dsh-render :render="tipModalRender"></dsh-render>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";
    import selectMixin from "./selectMixin.js";

    // optionKind值 'flat'、'dropdown'
    export default {
        name: "DshCheckbox",
        mixins: [controlMixin, selectMixin],
        props: {},
        data () {
            return {
                colorArr: [
                    "#CDE6FF",
                    "#C1FCFF",
                    "#C5FFD9",
                    "#FFEDC8",
                    "#FFDCAC",
                    "#FFD3B6",
                    "#EEB0FF",
                    "#D1B3FF",
                    "#B1C7FF",
                    "#DCDCDC",
                    "#6DAEF2",
                    "#40CBD2",
                    "#50C979",
                    "#FFC53B",
                    "#FF9300",
                    "#FA6400",
                    "#B620E0",
                    "#7E41DF",
                    "#25428D",
                    "#5D5D5D"
                ]
            };
        },
        computed: {
            listData () {
                return (this.propsObj._data || []).concat(this.initListData);
            }
            // // 选项数据
            // colData () {
            //     return (this.listData.filter(item => this.value[this.propsObj._key] || []).includes(item._key));
            // }
        },
        created () {},
        methods: {
            isDisabled (item) {
                return !!(
                    item._disabled ||
                    this.value[this.propsObj._key] && this.value[this.propsObj._key].length >= this.propsObj._max && !this.value[this.propsObj._key].includes(item._key) ||
                    !this.finalCanEdit
                );
            },

            // 下拉框的选择
            select (item) {
                let val = this.value[this.propsObj._key];
                if (val.includes(item.value)) {
                    let itemIndex = this.value[this.propsObj._key].findIndex(valItem => valItem === item.value);
                    val.splice(itemIndex, 1);
                } else {
                    val.push(item.value);
                }
                this.change(val, item);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshCheckbox.vue